import { AlertTitle, Stack } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { PoolBanner } from '@synergy/components-next';
import { ReactElement, useEffect, useState } from 'react';

import { ShoppingCartItemStatus } from '../../models/shopping-cart';
import { cartInfoSelector, shoppingCartSelector } from '../../store/shopping-cart-selectors';
import { useAppSelector } from '../../../store/store';

export const ShoppingCartPageNotifications = (): ReactElement | null => {
    const cart = useAppSelector(shoppingCartSelector);
    const cartInfos = useAppSelector(cartInfoSelector);
    const [showExceededMessage, setShowExceededMessage] = useState(false);
    const [showChangedMessage, setShowChangedMessage] = useState(false);

    useEffect(() => {
        const orderLimitExceeded =
            (cart?.perOrderOrderLimit !== undefined && cartInfos.total > cart.perOrderOrderLimit) ||
            (cart?.monthlyOrderLimit !== undefined && cartInfos.total > cart.monthlyOrderLimit);

        if (orderLimitExceeded) {
            setShowExceededMessage(true);
        }

        if (cart?.itemStatuses.includes(ShoppingCartItemStatus.Changed)) {
            setShowChangedMessage(true);
        }
    }, [cart, cartInfos]);

    if (
        !showExceededMessage &&
        cart?.itemStatuses.length === 1 &&
        cart?.itemStatuses[0] === ShoppingCartItemStatus.Available
    ) {
        return null;
    }

    return (
        <Stack gap={2}>
            {showExceededMessage && (
                <PoolBanner onClose={() => setShowExceededMessage(false)}>
                    <AlertTitle>
                        <FormattedMessage id="app.notification.limitExceeded.title" />
                    </AlertTitle>
                    <FormattedMessage id="app.notification.limitExceeded.text" />
                </PoolBanner>
            )}

            {showChangedMessage && (
                <PoolBanner severity="warning" onClose={() => setShowChangedMessage(false)}>
                    <AlertTitle>
                        <FormattedMessage id="app.notification.articleChanged.title" />
                    </AlertTitle>
                    <FormattedMessage id="app.notification.articleChanged.text" />
                </PoolBanner>
            )}

            {cart?.itemStatuses.includes(ShoppingCartItemStatus.Removed) && (
                <PoolBanner severity="error">
                    <AlertTitle>
                        <FormattedMessage id="app.notification.articleRemoved.title" />
                    </AlertTitle>
                    <FormattedMessage id="app.notification.articleRemoved.text" />
                </PoolBanner>
            )}

            {cart?.itemStatuses.includes(ShoppingCartItemStatus.PriceByRequest) && (
                <PoolBanner severity="error">
                    <AlertTitle>
                        <FormattedMessage id="app.notification.priceByRequest.title" />
                    </AlertTitle>
                    <FormattedMessage id="app.notification.priceByRequest.text" />
                </PoolBanner>
            )}
        </Stack>
    );
};
